import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["phone", "message"]

  close(event) {
    if (event) event.preventDefault()
    $('#whatsapp').modal('hide')
  }

  open(event) {
    event.preventDefault()

    const button  = event.currentTarget
    const phone   = button.dataset.phone
    const message = button.dataset.message

    this.phoneTarget.value   = phone || ""
    this.messageTarget.value = message || ""

    $('#whatsapp').modal('show')
  }

  abrirWhatsapp(event) {
    event.preventDefault()

    const rawPhone = this.phoneTarget.value.trim()
    const message = this.messageTarget.value.trim()
    const phone = this.normalizeArPhoneForWhatsApp(rawPhone)

    if (!phone) {
      alert("No hay un teléfono válido para WhatsApp.")
      return
    }

    const url = `https://wa.me/${phone}?text=${encodeURIComponent(message)}`
    window.open(url, "_blank")

    $('#whatsapp').modal('hide')
  }

  normalizeArPhoneForWhatsApp(rawPhone) {
    let d = (rawPhone || "").replace(/\D/g, "")
    if (!d) return ""

    if (d.startsWith("00")) d = d.slice(2)
    if (d.startsWith("549")) d = d.slice(3)
    else if (d.startsWith("54")) d = d.slice(2)
    if (d.startsWith("0")) d = d.slice(1)
    if (d.startsWith("9")) d = d.slice(1)

    if (/^\d{2,5}15\d{7}$/.test(d)) d = d.replace(/^(\d{2,5})15(\d{7})$/, "$1$2")

    if (d.length < 10) return ""

    return `549${d}`
  }
}
